/* eslint-disable no-throw-literal */
import ApiService from 'app/services/ApiService';
import normalizeById from 'app/utils/NormalizeById';

export const DIFFUSION_ADD = 'DIFFUSION_ADD';
export const DIFFUSION_BEGIN = 'DIFFUSION_BEGIN';
export const DIFFUSION_FAILURE = 'DIFFUSION_FAILURE';
export const DIFFUSION_CLEAR = 'DIFFUSION_CLEAR';

export function fetchDiffusion(data) {
	return async dispatch => {
        dispatch(diffusionBegin());
        await ApiService.getDiffusion(data)
			.then(
            result => {
               
                let normalized = normalizeById(result.Data, 'idDiffusion');
                    dispatch(diffusionAdd(normalized));
					return normalized;
				},
				error => {
                    dispatch(diffusionError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}


export const diffusionBegin = () => ({
    type: DIFFUSION_BEGIN,
});

export const diffusionAdd = data => ({
    type: DIFFUSION_ADD,
	payload: { data }
})

export const diffusionError = () => ({
    type: DIFFUSION_FAILURE,
})

export const diffusionClear = () =>({
    type: DIFFUSION_CLEAR,
})

